/* eslint-disable */
;globalThis["_sentryRouteManifest"] = "{\"dynamicRoutes\":[{\"path\":\"/directory/:shareToken\",\"regex\":\"^/directory/([^/]+)$\",\"paramNames\":[\"shareToken\"],\"hasOptionalPrefix\":false},{\"path\":\"/directory/:shareToken/:taskId\",\"regex\":\"^/directory/([^/]+)/([^/]+)$\",\"paramNames\":[\"shareToken\",\"taskId\"],\"hasOptionalPrefix\":false},{\"path\":\"/:project-id\",\"regex\":\"^/([^/]+)$\",\"paramNames\":[\"project-id\"],\"hasOptionalPrefix\":false},{\"path\":\"/:project-id/agents\",\"regex\":\"^/([^/]+)/agents$\",\"paramNames\":[\"project-id\"],\"hasOptionalPrefix\":false},{\"path\":\"/:project-id/agents/:agentRunId\",\"regex\":\"^/([^/]+)/agents/([^/]+)$\",\"paramNames\":[\"project-id\",\"agentRunId\"],\"hasOptionalPrefix\":false},{\"path\":\"/:project-id/cluster-expansion\",\"regex\":\"^/([^/]+)/cluster-expansion$\",\"paramNames\":[\"project-id\"],\"hasOptionalPrefix\":false},{\"path\":\"/:project-id/cluster-expansion/:id\",\"regex\":\"^/([^/]+)/cluster-expansion/([^/]+)$\",\"paramNames\":[\"project-id\",\"id\"],\"hasOptionalPrefix\":false},{\"path\":\"/:project-id/cluster-expansion/:id/:task-id\",\"regex\":\"^/([^/]+)/cluster-expansion/([^/]+)/([^/]+)$\",\"paramNames\":[\"project-id\",\"id\",\"task-id\"],\"hasOptionalPrefix\":false},{\"path\":\"/:project-id/cluster-expansion/template/:id\",\"regex\":\"^/([^/]+)/cluster-expansion/template/([^/]+)$\",\"paramNames\":[\"project-id\",\"id\"],\"hasOptionalPrefix\":false},{\"path\":\"/:project-id/dft-calculation\",\"regex\":\"^/([^/]+)/dft-calculation$\",\"paramNames\":[\"project-id\"],\"hasOptionalPrefix\":false},{\"path\":\"/:project-id/dft-calculation/:id\",\"regex\":\"^/([^/]+)/dft-calculation/([^/]+)$\",\"paramNames\":[\"project-id\",\"id\"],\"hasOptionalPrefix\":false},{\"path\":\"/:project-id/dft-calculation/:id/:task-id\",\"regex\":\"^/([^/]+)/dft-calculation/([^/]+)/([^/]+)$\",\"paramNames\":[\"project-id\",\"id\",\"task-id\"],\"hasOptionalPrefix\":false},{\"path\":\"/:project-id/jobs\",\"regex\":\"^/([^/]+)/jobs$\",\"paramNames\":[\"project-id\"],\"hasOptionalPrefix\":false},{\"path\":\"/:project-id/monte-carlo\",\"regex\":\"^/([^/]+)/monte-carlo$\",\"paramNames\":[\"project-id\"],\"hasOptionalPrefix\":false},{\"path\":\"/:project-id/monte-carlo/:id\",\"regex\":\"^/([^/]+)/monte-carlo/([^/]+)$\",\"paramNames\":[\"project-id\",\"id\"],\"hasOptionalPrefix\":false},{\"path\":\"/:project-id/nudged-elastic-band\",\"regex\":\"^/([^/]+)/nudged-elastic-band$\",\"paramNames\":[\"project-id\"],\"hasOptionalPrefix\":false},{\"path\":\"/:project-id/nudged-elastic-band/:id\",\"regex\":\"^/([^/]+)/nudged-elastic-band/([^/]+)$\",\"paramNames\":[\"project-id\",\"id\"],\"hasOptionalPrefix\":false},{\"path\":\"/:project-id/nudged-elastic-band/:id/:task-id\",\"regex\":\"^/([^/]+)/nudged-elastic-band/([^/]+)/([^/]+)$\",\"paramNames\":[\"project-id\",\"id\",\"task-id\"],\"hasOptionalPrefix\":false},{\"path\":\"/:project-id/phase-field\",\"regex\":\"^/([^/]+)/phase-field$\",\"paramNames\":[\"project-id\"],\"hasOptionalPrefix\":false},{\"path\":\"/:project-id/phase-field/:id\",\"regex\":\"^/([^/]+)/phase-field/([^/]+)$\",\"paramNames\":[\"project-id\",\"id\"],\"hasOptionalPrefix\":false},{\"path\":\"/:project-id/sqs-builder\",\"regex\":\"^/([^/]+)/sqs-builder$\",\"paramNames\":[\"project-id\"],\"hasOptionalPrefix\":false},{\"path\":\"/:project-id/sqs-builder/:id\",\"regex\":\"^/([^/]+)/sqs-builder/([^/]+)$\",\"paramNames\":[\"project-id\",\"id\"],\"hasOptionalPrefix\":false},{\"path\":\"/:project-id/sqs-builder/:id/:task-id\",\"regex\":\"^/([^/]+)/sqs-builder/([^/]+)/([^/]+)$\",\"paramNames\":[\"project-id\",\"id\",\"task-id\"],\"hasOptionalPrefix\":false},{\"path\":\"/:project-id/structure-builder\",\"regex\":\"^/([^/]+)/structure-builder$\",\"paramNames\":[\"project-id\"],\"hasOptionalPrefix\":false},{\"path\":\"/:project-id/structure-builder/:structure-id\",\"regex\":\"^/([^/]+)/structure-builder/([^/]+)$\",\"paramNames\":[\"project-id\",\"structure-id\"],\"hasOptionalPrefix\":false},{\"path\":\"/:project-id/structure-builder/materials-external/:materials-external-id\",\"regex\":\"^/([^/]+)/structure-builder/materials-external/([^/]+)$\",\"paramNames\":[\"project-id\",\"materials-external-id\"],\"hasOptionalPrefix\":false},{\"path\":\"/:project-id/structure-builder/template/:id\",\"regex\":\"^/([^/]+)/structure-builder/template/([^/]+)$\",\"paramNames\":[\"project-id\",\"id\"],\"hasOptionalPrefix\":false},{\"path\":\"/:project-id/template-builder\",\"regex\":\"^/([^/]+)/template-builder$\",\"paramNames\":[\"project-id\"],\"hasOptionalPrefix\":false},{\"path\":\"/:project-id/template-builder/template/:id\",\"regex\":\"^/([^/]+)/template-builder/template/([^/]+)$\",\"paramNames\":[\"project-id\",\"id\"],\"hasOptionalPrefix\":false},{\"path\":\"/:project-id/workflows\",\"regex\":\"^/([^/]+)/workflows$\",\"paramNames\":[\"project-id\"],\"hasOptionalPrefix\":false},{\"path\":\"/:project-id/workflows/:id\",\"regex\":\"^/([^/]+)/workflows/([^/]+)$\",\"paramNames\":[\"project-id\",\"id\"],\"hasOptionalPrefix\":false},{\"path\":\"/:project-id/workflows/:id/:task-id\",\"regex\":\"^/([^/]+)/workflows/([^/]+)/([^/]+)$\",\"paramNames\":[\"project-id\",\"id\",\"task-id\"],\"hasOptionalPrefix\":false},{\"path\":\"/:project-id/workflows/create\",\"regex\":\"^/([^/]+)/workflows/create$\",\"paramNames\":[\"project-id\"],\"hasOptionalPrefix\":false},{\"path\":\"/report/:reportId\",\"regex\":\"^/report/([^/]+)$\",\"paramNames\":[\"reportId\"],\"hasOptionalPrefix\":false},{\"path\":\"/structures/:task-id\",\"regex\":\"^/structures/([^/]+)$\",\"paramNames\":[\"task-id\"],\"hasOptionalPrefix\":false}],\"staticRoutes\":[{\"path\":\"/\"},{\"path\":\"/log-in\"},{\"path\":\"/log-in/forgot-password\"},{\"path\":\"/log-in/forgot-password/reset-password\"},{\"path\":\"/sign-up\"},{\"path\":\"/sign-up/verify-email\"},{\"path\":\"/directory\"},{\"path\":\"/docs\"},{\"path\":\"/docs/agentic\"},{\"path\":\"/docs/ai\"},{\"path\":\"/docs/cluster-expansion\"},{\"path\":\"/docs/dft\"},{\"path\":\"/docs/structure-builder\"},{\"path\":\"/docs/workflows\"},{\"path\":\"/email-verification\"},{\"path\":\"/email-verification/reset-password\"},{\"path\":\"/organization\"},{\"path\":\"/profile\"},{\"path\":\"/skills\"},{\"path\":\"/structures\"}],\"isrRoutes\":[]}";globalThis["_sentryNextJsVersion"] = "16.4.1";import posthog from "posthog-js";

posthog.init(process.env.NEXT_PUBLIC_POSTHOG_KEY!, {
  api_host: "/ingest",
  ui_host: "https://eu.posthog.com",
  defaults: "2025-05-24",
  capture_exceptions: true,
  debug: false,
});


// This file configures the initialization of Sentry on the client.
// The added config here will be used whenever a users loads a page in their browser.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/

import * as Sentry from "@sentry/nextjs";

/**
 * Workaround for React event handling bug: nodeName.toLowerCase is not a function.
 *
 * This error occurs when React processes events and the target element's nodeName is
 * undefined or not a string. The error originates from React's internal event
 * handling code (react-dom-client.production.js:13919), not from application code.
 *
 * The workaround intercepts the error at multiple levels:
 * 1. Polyfill: Ensures EventTarget instances have a safe nodeName property.
 * 2. Error handler: Catches and suppresses the specific error.
 * 3. Sentry filter: Prevents the error from being reported.
 */
if (typeof window !== "undefined") {
  // Polyfill: Ensure EventTarget.prototype has a safe nodeName getter
  // This prevents the error by ensuring nodeName always returns a string
  if (!Object.hasOwn(EventTarget.prototype, "nodeName")) {
    Object.defineProperty(EventTarget.prototype, "nodeName", {
      get() {
        // For actual DOM nodes, return their nodeName
        if (this instanceof Node) {
          return this.nodeName;
        }

        // For other EventTarget instances, return empty string
        return "";
      },
      configurable: true,
      enumerable: false,
    });
  }

  // Global error handler: Catch and suppress the specific React error
  const originalOnError = window.onerror;
  window.onerror = (
    message: Event | string,
    source?: string,
    lineno?: number,
    colno?: number,
    error?: Error | null
  ): boolean => {
    // Check if this is the specific React nodeName error
    const isNodeNameError =
      error instanceof TypeError &&
      (error.message.includes("nodeName.toLowerCase is not a function") ||
        error.message.includes("l.nodeName.toLowerCase is not a function") ||
        error.message.includes("i.nodeName.toLowerCase is not a function"));

    if (isNodeNameError) {
      // Suppress the error silently - it's a known React/Next.js bug
      return true;
    }

    // Call original error handler for other errors
    if (originalOnError) {
      return originalOnError.call(
        window,
        message,
        source,
        lineno,
        colno,
        error ?? undefined
      );
    }

    return false;
  };

  // Catch unhandled promise rejections with the same error
  window.addEventListener("unhandledrejection", (event) => {
    const isNodeNameError =
      event.reason instanceof TypeError &&
      (event.reason.message.includes(
        "nodeName.toLowerCase is not a function"
      ) ||
        event.reason.message.includes(
          "l.nodeName.toLowerCase is not a function"
        ) ||
        event.reason.message.includes(
          "i.nodeName.toLowerCase is not a function"
        ));

    if (isNodeNameError) {
      event.preventDefault();
    }
  });
}

Sentry.init({
  dsn: "https://5ec8091f768e6f84bdc364972dda877a@o4510028543492096.ingest.de.sentry.io/4510028544802896",

  environment: process.env.ENVIRONMENT || "production",

  // Add optional integrations for additional features
  integrations: [
    Sentry.replayIntegration(),
    // Sentry.feedbackIntegration({
    //   useSentryUser: {
    //     email: "email",
    //     name: "username",
    //   },
    //   themeLight: {
    //     accentBackground: "#29c2a1",
    //   },
    //   themeDark: {
    //     accentBackground: "#29c2a1",
    //   },
    // }),
  ],

  // Filter out the React nodeName.toLowerCase error from Sentry
  // This prevents the error from being reported since it's a known React/Next.js bug
  beforeSend(event, hint) {
    const error = hint.originalException;
    const isNodeNameError =
      error instanceof TypeError &&
      (error.message.includes("nodeName.toLowerCase is not a function") ||
        error.message.includes("l.nodeName.toLowerCase is not a function") ||
        error.message.includes("i.nodeName.toLowerCase is not a function"));

    if (isNodeNameError) {
      // Suppress the error
      return null;
    }

    return event;
  },

  // Define how likely traces are sampled. Adjust this value in production, or use tracesSampler for greater control.
  tracesSampleRate: 1,
  // Enable logs to be sent to Sentry
  enableLogs: true,

  // Define how likely Replay events are sampled.
  // This sets the sample rate to be 10%. You may want this to be 100% while
  // in development and sample at a lower rate in production
  replaysSessionSampleRate: 0.0,

  // Define how likely Replay events are sampled when an error occurs.
  replaysOnErrorSampleRate: 1.0,

  // Setting this option to true will print useful information to the console while you're setting up Sentry.
  debug: false,
});

export const onRouterTransitionStart = Sentry.captureRouterTransitionStart;
